import { CustomObject } from 'types/common'
import Api from './axiosInstance'
import { API_ORDER } from 'utils/constants'

type FetchOrdersParams = {
  limit: number
  page: number
  search?: string
  filters?: any
}

export const fetchOrders = ({
  limit,
  page,
  search,
  filters,
}: FetchOrdersParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_ORDER.ORDERS}?${params}`,
  })
}

export const fetchStoreOrders = ({
  limit,
  page,
  filters,
  search,
}: FetchOrdersParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })
  return Api.get({
    url: `${API_ORDER.ORDERS_BY_STORE}?${params}`,
  })
}

export const fetchOrder = (orderId: string) => {
  return Api.get({ url: `${API_ORDER.ORDERS}/${orderId}` })
}

export const createFullRma = (orderId: string, data: CustomObject) => {
  return Api.post({ url: `${API_ORDER.ORDERS}/${orderId}/full-rma`, data })
}

export const createPartialRma = (orderId: string, data: CustomObject) => {
  return Api.post({ url: `${API_ORDER.ORDERS}/${orderId}/partial-rma`, data })
}

export const fetchRmaDetails = (rmaId: string) => {
  return Api.get({ url: `${API_ORDER.ORDERS}/rma/${rmaId}` })
}

export const downloadOrders = ({
  filters,
}: {
  filters: Record<string, any>
}) => {
  const params = new URLSearchParams(filters)
  return Api.get({
    url: `${API_ORDER.ORDERS_EXPORT}?${params}`,
  })
}

export const triggerOrderSync = () => {
  return Api.get({ url: API_ORDER.ORDERS_SYNC })
}

export const triggerReconciliationSync = () => {
  return Api.get({ url: API_ORDER.RECONCILIATION_SYNC })
}
